import {Directive, ElementRef, Input} from '@angular/core';
import * as Inputmask from 'inputmask'; // to install inputmask: npm install inputmask --save
/*
*   Allowed HTML-elements:
*   <input type="text">
*   <input type="search">
*   <input type="tel">
*   <input type="password">
*   <div contenteditable="true"> (and all others supported by contenteditable)
*   <textarea>
*   any html-element (mask text content or set maskedvalue with jQuery.val)
*   The allowed input types are defined in the supportsInputType option
*
*   For more documentation go to: https://www.npmjs.com/package/inputmask
*
* */

@Directive({
  selector: '[restrict-input],[mask-input]',
})
export class RestrictInputDirective {

  // map of some of the regex strings (TODO: add your own)
  private regexMap = {
    integer: '^[0-9]*$',
    float: '^[+-]?([0-9]*[.])?[0-9]+$',
    words: '([A-z]*\\S)*',
    point25: '^\-?[0-9]*(?:\\.25|\\.50|\\.75|)$',
    date: '^[0-9]*$',
    month: '^[0-9]*$',
    year: '^[0-9]*$',
    nameText: '^[a-zA-Z0-9\'-\\s]*$',
  };

  // map of some of the regex strings (TODO: add your own)
  private placeholderMap = {
    date: 'mm/dd/yyyy',
    month: 'mm/yyyy',
    year: 'yyyy',
    hours:'99.9'
   
  };



  // map of some of the masks strings (TODO: add your own)
  private maskMap = {
    telephone: '(999) 999-9999',
    date: '99/99/9999',
    month: '99/9999',
    currency: 'currency',
    integer: 'integer',
    decimal: 'decimal',
    year: '9999',
    hours: 'decimal',
    email: 'email',
    ssn: "999-99-9999",
    zipcode: "99999-9999"
  };

  constructor(private el: ElementRef) {}

  @Input('restrict-input')
  public set defineInputType(type: string) {
    Inputmask({regex: this.regexMap[type]})
      .mask(this.el.nativeElement);
  }

  @Input('mask-input')
  public set maskInputType(type: string) {

    let doClear = (type === 'date' || type === 'telephone' || type ==='email' || type ==='month');
    let allowMinus = !(type === 'hours' );

    Inputmask(this.maskMap[type], {
      placeholder: this.placeholderMap[type],
      autoUnmask: true,
      clearIncomplete: doClear,
      rightAlign: false,
      allowMinus: allowMinus,
    })
      .mask(this.el.nativeElement);
    /*Inputmask({mask: this.maskMap[type], autoUnmask:true})
      .mask(this.el.nativeElement);*/
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/RestrictInputDirective.directive.ts